import { render, staticRenderFns } from "./FeedBackMessage.vue?vue&type=template&id=9fe1fcd6&"
import script from "./FeedBackMessage.vue?vue&type=script&lang=ts&"
export * from "./FeedBackMessage.vue?vue&type=script&lang=ts&"
import style0 from "./FeedBackMessage.vue?vue&type=style&index=0&id=9fe1fcd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports